<template>
  <div>
    <TextFormGroup
        :value="value.ad_unit_id"
        name="ad_unit_id"
        label="Ad Unit ID"
        :error="(errors.ad_unit_id || [])[0]"
        @input="emit('ad_unit_id', $event)"
    />
    <TextFormGroup
        :value="value.keyword"
        name="keyword"
        label="Keyword"
        :error="(errors.keyword || [])[0]"
        @input="emit('keyword', $event)"
    />
    <SelectFormGroup
        :value="value.keyword_driver"
        name="keyword_driver"
        label="Keyword Type"
        :error="(errors.keyword_driver || [])[0]"
        :options="[{value: 'value', label: 'Value'}, {value: 'context', label: 'Context'}]"
        @input="emit('keyword_driver', $event)"
    />
  </div>
</template>

<script>
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: {SelectFormGroup, TextFormGroup},

  props: {
    value: {
      required: true
    },

    errors: {
      required: true
    }
  },

  methods: {
    emit(key, value) {
      this.$emit('input', {...this.value, [key]: value})
    },
  }
}
</script>
